import React, { useState } from 'react';
import {
  countryOptions,
  extractCountryCode,
  validatePhoneNumber,
  stripCountryCode
} from '../../utils/phoneUtils';
import './EditUserModal.css';

const EditUserModal = ({ onClose, onSave, user }) => {
  const initOpt =
    countryOptions.find(o => user.Phone?.startsWith(o.code)) ||
    countryOptions[0];
  const initNational = stripCountryCode(user.Phone || '');

  const [name, setName] = useState(user.Name || '');
  const [countryLabel, setCountryLabel] = useState(initOpt.label);
  const [isActive, setIsActive] = useState(user?.Status?.toLowerCase() === 'active');

  const phone = initNational;

  const phoneErrorMsg = validatePhoneNumber(countryLabel, phone);
  const isPhoneValid = phoneErrorMsg === '';

  const handleSaveClick = () => {
    if (!isPhoneValid) return;
    const digits = phone.replace(/\D/g, '');
    const cc = extractCountryCode(countryLabel);
    const full = `${cc}${digits}`;
    const status = isActive ? 'active' : 'inactive';
    onSave(user, name.trim(), full, status);
    onClose();
  };

  return (
    <div className="edit-user-backdrop">
      <div className="edit-user-modal">
        <h2>Edit User</h2>

        <div className="edit-user-input-group">
          <label className="edit-user-label">Name</label>
          <input
            type="text"
            placeholder="Enter new name"
            value={name}
            onChange={e => setName(e.target.value)}
            className="edit-user-input"
          />
        </div>

        <div className="edit-user-input-group">
          <label className="edit-user-label">Country/Region</label>
          <select
            className="edit-user-input"
            value={countryLabel}
            onChange={e => setCountryLabel(e.target.value)}
          >
            {countryOptions.map(o => (
              <option key={o.code + o.label} value={o.label}>
                {o.label}
              </option>
            ))}
          </select>
        </div>

        <div className="edit-user-input-group">
          <label className="edit-user-label">Phone Number</label>
          <input
            type="tel"
            value={phone}
            readOnly
            className="edit-user-input"
          />
        </div>

        <div className="edit-user-input-group">
          <label className="edit-user-checkbox-label">
            <input
              type="checkbox"
              checked={isActive}
              onChange={e => setIsActive(e.target.checked)}
              className="edit-user-checkbox"
            />
            Active
          </label>
        </div>

        <div className="edit-user-actions">
          <button onClick={onClose} className="edit-user-button cancel">
            Cancel
          </button>
          <button onClick={handleSaveClick} className="edit-user-button save">
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditUserModal;